import { render, staticRenderFns } from "./VehicleWithService.vue?vue&type=template&id=6d5b10e6&scoped=true&"
import script from "./VehicleWithService.vue?vue&type=script&lang=js&"
export * from "./VehicleWithService.vue?vue&type=script&lang=js&"
import style0 from "./VehicleWithService.vue?vue&type=style&index=0&id=6d5b10e6&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d5b10e6",
  null
  
)

export default component.exports